import PropTypes from 'prop-types';
import React from 'react';
import ProductCardDiscountedPrice from '../ProductCardDiscountedPrice';
import useSummerDiscountPriceBeforeDiscount from './useSummerDiscountPriceBeforeDiscount';

export default function SummerDiscountPrice({localizedPrice, price, quantity}) {
  const {localizedPriceBeforeDiscount} =
    useSummerDiscountPriceBeforeDiscount(price);

  return (
    <ProductCardDiscountedPrice
      discountedPrice={localizedPrice}
      originalPrice={localizedPriceBeforeDiscount}
      quantity={quantity}
    />
  );
}

SummerDiscountPrice.propTypes = {
  localizedPrice: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired
};
